import { networkErrorAction } from '../actions/UiActions';

export default class CompoundFetch {

	/**
	 * @param {Function} dispatch
	 * @param {object} data
	 * @param {string} name
	 * @return {*}
	 */
	static parseSubRequest(dispatch, data, name) {
		const statusCode = data && data.statusCode ? data.statusCode : 'unknown';

		if (statusCode !== 200) {
			const msg = 'Sub-request for ' + name + ' returned status code ' + statusCode;
			dispatch(networkErrorAction(msg));
			return false;
		}

		try {
			return JSON.parse(data.body);
		}
		catch (error) {
			const msg = 'Sub-request body for ' + name + ' returned invalid JSON.';
			dispatch(networkErrorAction(msg));
		}
		return false;
	}
}


// WEBPACK FOOTER //
// ./helpers/CompoundFetch.js